import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';

const Servicios = () => {
  const [activeTab, setActiveTab] = useState('mercantil');

  const services = {
    mercantil: {
      title: 'Derecho Mercantil y Corporativo',
      description: 'El derecho empresarial y corporativo es una disciplina jurídica especializada, a partir del auge de las PyMEs (pequeñas y medianas empresas), derivada de los principios y contenidos del Derecho Mercantil.',
      image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/4scpyxku_servicio%202.png',
      items: [
        'Constitución de sociedades y asociaciones',
        'Escisión de sociedades',
        'Fusión de Sociedades',
        'Transformación de Sociedad',
        'Protocolización de Actas de Asamblea y Consejo',
        'Aumento de Capital',
        'Reducción de Capital',
        'Cambio de Razón Social',
        'Cambio de Domicilio Social',
        'Cambio de Objeto Social',
        'Disolución y Liquidación de Sociedades',
        'Emisión de Obligaciones'
      ]
    },
    civil: {
      title: 'Derecho Civil',
      description: 'El Derecho Civil regula aspectos fundamentales de las relaciones entre personas, incluyendo temas relacionados con personas, bienes, sucesiones, obligaciones y contratos. Nuestros servicios garantizan la legalidad y claridad en cada acto jurídico para prevenir conflictos futuros.',
      image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/uinlujon_servicios%201.jpg',
      items: [
        'Testamentos',
        'Poderes / Mandatos',
        'Revocación de poderes',
        'Sucesiones Intestamentarias',
        'Sucesiones Testamentarias',
        'Cesiones de Derechos',
        'Convenios',
        'Contratos',
        'Ratificación de firmas',
        'Reconocimiento de Adeudos',
        'Capitulaciones Matrimoniales',
        'Divorcios (voluntarios y por mutuo consentimiento)'
      ]
    },
    inmobiliario: {
      title: 'Derecho Inmobiliario',
      description: 'Especialistas en todas las operaciones relacionadas con la enajenación de bienes inmuebles y transacciones comerciales. Estructuramos cada operación para el cumplimiento en cuanto a contratos, permisos y en materia fiscal, adaptando cada proyecto según su tipo o ubicación.',
      image: 'https://customer-assets.emergentagent.com/job_public-notary-lab/artifacts/cq2w1hyn_servicio%202.png',
      items: [
        'Compraventa',
        'Donación',
        'Permuta',
        'Dación en Pago',
        'Adjudicación',
        'Constitución de Condominios',
        'Aportación a Sociedades',
        'Adjudicaciones por Herencia',
        'Adjudicaciones Diversas',
        'Préstamos con garantía hipotecaria',
        'Apertura de crédito simple con garantía hipotecaria',
        'Cancelación de hipoteca',
        'Declaratoria de obra nueva',
        'Fusión y Subdivisión de predios'
      ]
    },
    otros: {
      title: 'Otros Servicios',
      description: 'Servicios notariales adicionales y asesoría especializada para cubrir todas tus necesidades legales con la certeza y profesionalismo que nos caracteriza.',
      image: null,
      items: [
        'Fe de hechos',
        'Certificación de documentos',
        'Asesoría legal preventiva',
        'Consultoría jurídica personalizada',
        'Trámites especiales',
        'Arbitraje (solución alternativa de controversias)',
        'Notarización de documentos',
        'Apostilla de documentos',
        'Legalización de firmas'
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-notaria-primary to-notaria-secondary py-16 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Nuestros Servicios
            </h1>
            <p className="text-xl text-gray-100">
              Soluciones jurídicas especializadas con la certeza legal que tu negocio o patrimonio necesitan
            </p>
          </div>
        </div>
      </section>

      {/* Tabs Navigation */}
      <div className="bg-gray-50 border-b">
        <div className="container mx-auto px-4">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full justify-start bg-transparent border-0 h-auto p-0">
              <TabsTrigger 
                value="mercantil" 
                className="px-8 py-4 text-base font-medium data-[state=active]:bg-white data-[state=active]:border-b-2 data-[state=active]:border-notaria-secondary data-[state=active]:text-notaria-secondary rounded-none"
              >
                Derecho Mercantil y Corporativo
              </TabsTrigger>
              <TabsTrigger 
                value="civil" 
                className="px-8 py-4 text-base font-medium data-[state=active]:bg-white data-[state=active]:border-b-2 data-[state=active]:border-notaria-secondary data-[state=active]:text-notaria-secondary rounded-none"
              >
                Derecho Civil
              </TabsTrigger>
              <TabsTrigger 
                value="inmobiliario" 
                className="px-8 py-4 text-base font-medium data-[state=active]:bg-white data-[state=active]:border-b-2 data-[state=active]:border-notaria-secondary data-[state=active]:text-notaria-secondary rounded-none"
              >
                Derecho Inmobiliario
              </TabsTrigger>
              <TabsTrigger 
                value="otros" 
                className="px-8 py-4 text-base font-medium data-[state=active]:bg-white data-[state=active]:border-b-2 data-[state=active]:border-notaria-secondary data-[state=active]:text-notaria-secondary rounded-none"
              >
                Otros
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>

      {/* Content Area */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div
            className={`grid grid-cols-1 ${
              services[activeTab]?.image ? 'lg:grid-cols-2' : 'lg:grid-cols-1'
            } gap-12 items-center max-w-6xl mx-auto`}
          >
            {/* Image/Video - Changes based on active tab. Hidden when service has no image. */}
            {services[activeTab]?.image && (
              <div className="order-2 lg:order-1">
                {Object.entries(services).map(([key, service]) =>
                  !service.image ? null : service.isVideo ? (
                    <video
                      key={key}
                      src={service.image}
                      autoPlay
                      loop
                      muted
                      playsInline
                      controls
                      className={`w-full h-auto rounded-lg shadow-lg bg-notaria-primary transition-opacity duration-300 ${activeTab === key ? 'block' : 'hidden'}`}
                    />
                  ) : (
                    <img
                      key={key}
                      src={service.image}
                      alt={service.title}
                      className={`w-full h-auto rounded-lg shadow-lg transition-opacity duration-300 ${activeTab === key ? 'block' : 'hidden'}`}
                    />
                  )
                )}
              </div>
            )}

            {/* Content */}
            <div className="order-1 lg:order-2">
              {Object.entries(services).map(([key, service]) => (
                <div key={key} className={activeTab === key ? 'block' : 'hidden'}>
                  <h2 className="text-4xl font-bold text-notaria-primary mb-6">
                    {service.title}
                  </h2>
                  <p className="text-gray-700 text-lg mb-8">
                    {service.description}
                  </p>
                  <ul className="space-y-3">
                    {service.items.map((item, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-notaria-secondary mt-0.5 flex-shrink-0" />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicios;
